import React, { useEffect, useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import ApiService from "../../Services/ApiService";
import parse from "html-react-parser";

const CancellationPolicy = () => {
  const [policy, setPolicy] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await ApiService.getCancellationPolicy();
      setPolicy(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  }

  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner PageTitle={"Cancellation Policy"}
      breadCrumpPageTitle={'Cancellation Policy'}
      />
      <div className="text-content-page-container d-flex flex-column align-items-center">
        <h2 className="Heading fw-600 mb-2 headingColor text-center">
          {policy?.title ?? "Cancellation Policy"}
        </h2>

        <div>
          {policy?.details && parse(policy.details)}
        </div>
      </div>
    </div>
  );
};
export default CancellationPolicy;
